function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDBF7"
    },
    d: "M66.831,357.818c-5.507,5.507-11.49,8.454-13.361,6.582c-1.872-1.872,1.075-7.854,6.583-13.362 c5.507-5.507,11.489-8.454,13.361-6.582C75.286,346.328,72.338,352.31,66.831,357.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDBF7"
    },
    d: "M90.999,257.089c-17.901,17.901-33.838,30.986-35.597,29.226 c-1.759-1.759,11.326-17.697,29.226-35.598s33.838-30.986,35.598-29.226S108.899,239.188,90.999,257.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#BEDBF7",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    d: "M670.403,357.552H556.462 c-6.111,0-11.065-4.954-11.065-11.065v-153.05c0-6.111,4.954-11.065,11.065-11.065h113.941c6.111,0,11.065,4.954,11.065,11.065 v153.05C681.468,352.598,676.514,357.552,670.403,357.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#BEDBF7",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    d: "M354.886,219.867H131.518 c-6.15,0-11.135-4.985-11.135-11.135v-106.89c0-6.15,4.985-11.135,11.135-11.135h223.367c6.15,0,11.135,4.985,11.135,11.135 v106.89C366.02,214.882,361.035,219.867,354.886,219.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC40"
    },
    d: "M361.517,127.031c-159.29,0-288.419,129.13-288.419,288.419c0,0.369,0.013,0.735,0.014,1.104 h576.81c0.001-0.369,0.014-0.735,0.014-1.104C649.936,256.161,520.807,127.031,361.517,127.031z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A845"
    },
    d: "M674.349,326.141c0,0-2,3.967,1.2,17.086c3.201,13.118,0.8,18.46-4.801,26.591 c-5.601,8.131-22.203,25.533-21.203,46.737h-31.99c0,0,5.786-14.202,7.387-27.604c1.6-13.402,9.849-21.403,22.327-27.804 C659.746,354.745,663.747,330.341,674.349,326.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#283847",
      strokeWidth: 1.2169,
      strokeMiterlimit: 10
    },
    d: "M674.349,326.141 c0,0-7.401,6.368-8.401,17.086c-1,10.718-2.6,18.919-12.002,28.121c-9.401,9.201-20.603,23.003-20.603,45.207"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283847"
    },
    d: "M653.636,355.718c-1.881,2.293-3.966,4.196-6.368,5.428 c-12.478,6.401-20.727,14.402-22.327,27.804c-1.6,13.402-7.387,27.604-7.387,27.604h31.99 c-0.525-11.127,3.799-21.205,8.836-29.448C656.386,376.233,654.069,364.369,653.636,355.718z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A845"
    },
    d: "M674.349,228.426c0,0-2.4,4.201,0,15.002c2.4,10.802,3.867,24.304-1.067,30.305 c-4.934,6.001-12.435,13.202-15.136,25.804c-2.7,12.602,3.601,21.603-3,32.405c-6.601,10.802-12.902,12.453-14.102,26.929 c-1.2,14.477,9.901,28.279-16.503,57.683h-59.955c0,0,18.849-35.405,24.249-54.008c5.401-18.603,0.9-27.304,9.301-40.056 c8.401-12.752,20.103-8.868,25.204-20.711c5.101-11.843,5.101-22.045,12.302-29.546c7.201-7.501,18.903-10.502,23.529-22.016 C663.646,239.08,670.448,230.226,674.349,228.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#283847",
      strokeWidth: 1.2169,
      strokeMiterlimit: 10
    },
    d: "M674.349,228.426 c-9.198,10.099-9.601,22.703-10.201,31.905c-0.6,9.201-14.402,12.202-19.203,24.504c-4.801,12.302-4.201,23.762-9.902,34.234 c-5.701,10.473-14.702,11.673-21.003,26.075c-6.301,14.402,3.301,47.407-19.203,71.411"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 12.7164 395.1378)",
    style: {
      fill: "#FF9D38"
    },
    cx: 483.332,
    cy: 182.219,
    rx: 108.775,
    ry: 108.775
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC40"
    },
    d: "M584.24,102.651c-22.512,0-40.762,18.25-40.762,40.761c0,4.505,0.742,8.835,2.091,12.886 l-20.406,22.674l28.042-9.148c7.477,8.776,18.601,14.349,31.034,14.349c22.512,0,40.761-18.25,40.761-40.762 C625.001,120.901,606.752,102.651,584.24,102.651z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A845"
    },
    d: "M580.238,161.584c-0.804,0-1.607-0.307-2.221-0.92l-19.777-19.777 c-1.227-1.226-1.227-3.215,0-4.441c1.227-1.227,3.214-1.227,4.441,0l17.557,17.556l25.561-25.559 c1.227-1.227,3.214-1.227,4.441,0c1.227,1.226,1.227,3.215,0,4.441l-27.781,27.781 C581.845,161.277,581.041,161.584,580.238,161.584z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A845"
    },
    d: "M99.176,228.426c0,0,2.4,4.201,0,15.002c-2.4,10.802-3.867,24.304,1.067,30.305 c4.934,6.001,12.435,13.202,15.136,25.804c2.7,12.602-3.601,21.603,3,32.405c6.601,10.802,12.902,12.453,14.102,26.929 c1.2,14.477-9.902,28.279,16.503,57.683h59.955c0,0-18.849-35.405-24.249-54.008c-5.401-18.603-0.9-27.304-9.301-40.056 c-8.401-12.752-20.103-8.868-25.204-20.711c-5.101-11.843-5.101-22.045-12.302-29.546c-7.201-7.501-18.903-10.502-23.529-22.016 C109.878,239.08,103.077,230.226,99.176,228.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283847"
    },
    d: "M132.481,358.871c1.2,14.477-9.902,28.279,16.503,57.683h59.955c0,0-18.849-35.405-24.249-54.008 c-5.401-18.603-0.9-27.304-9.301-40.056c-8.401-12.752-20.103-8.868-25.204-20.711c-5.101-11.843-5.101-22.045-12.302-29.546 c-0.992-1.033-2.074-1.976-3.206-2.872c-0.124,21.125-4.384,55.286-6.254,76.104C130.475,348.714,131.96,352.582,132.481,358.871 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#283847",
      strokeWidth: 1.2169,
      strokeMiterlimit: 10
    },
    d: "M99.176,228.426 c9.198,10.099,9.601,22.703,10.201,31.905c0.6,9.201,14.402,12.202,19.203,24.504c4.801,12.302,4.201,23.762,9.902,34.234 c5.701,10.473,14.702,11.673,21.003,26.075c6.301,14.402-3.301,47.407,19.203,71.411"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M414.464,358.871H147.951c-5.945,0-10.765-4.82-10.765-10.765v-213.03 c0-5.946,4.82-10.765,10.765-10.765h266.513c5.945,0,10.765,4.82,10.765,10.765v213.03 C425.229,354.051,420.409,358.871,414.464,358.871z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EEF7"
    },
    d: "M341.817,154.142v204.729h72.647c5.945,0,10.765-4.82,10.765-10.765V154.142H341.817z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 355.7755 189.1204)",
    style: {
      fill: "#3A65C9",
      fontFamily: "'Montserrat-Bold'",
      fontSize: "12.802px"
    }
  }, "AUGUST"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    d: "M356.803,219.867 c0,1.901-1.541,3.443-3.443,3.443c-1.901,0-3.443-1.541-3.443-3.443c0-1.901,1.541-3.443,3.443-3.443 C355.262,216.424,356.803,217.965,356.803,219.867z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 361.82,
    y1: 219.867,
    x2: 413.478,
    y2: 219.867
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    cx: 353.361,
    cy: 247.706,
    r: 3.443
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 361.82,
    y1: 247.706,
    x2: 413.478,
    y2: 247.706
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    cx: 353.361,
    cy: 275.545,
    r: 3.443
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 361.82,
    y1: 275.545,
    x2: 413.478,
    y2: 275.545
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1561 -0.9877 0.9877 0.1561 -45.5525 358.1231)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 186.802,
    cy: 205.719,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -82.8811 211.3461)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 213.677,
    cy: 205.719,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2289 -0.9735 0.9735 0.2289 -14.7636 392.8015)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 240.552,
    cy: 205.719,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1597 -0.9872 0.9872 0.1597 21.6305 436.8509)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 267.426,
    cy: 205.719,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1597 -0.9872 0.9872 0.1597 44.2125 463.3807)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 294.301,
    cy: 205.719,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1629 -0.9866 0.9866 0.1629 65.8759 489.0856)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 321.176,
    cy: 205.719,
    rx: 8.939,
    ry: 8.939
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 159.927,
    cy: 236.905,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 186.802,
    cy: 236.905,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 213.677,
    cy: 236.905,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5521"
    },
    cx: 240.552,
    cy: 236.905,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 267.426,
    cy: 236.905,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 294.301,
    cy: 236.905,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 321.176,
    cy: 236.905,
    r: 8.939
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 159.927,
    cy: 268.091,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 186.802,
    cy: 268.091,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 213.677,
    cy: 268.091,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 240.552,
    cy: 268.091,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 267.426,
    cy: 268.091,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 294.301,
    cy: 268.091,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 321.176,
    cy: 268.091,
    r: 8.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -102.3549 83.9827)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 159.927,
    cy: 299.277,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9315 -0.3637 0.3637 0.9315 -96.0636 88.448)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 186.802,
    cy: 299.277,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2306 -0.973 0.973 0.2306 -126.8138 438.1691)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 213.677,
    cy: 299.277,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -141.1651 257.7519)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 240.552,
    cy: 299.277,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9247 -0.3806 0.3806 0.9247 -93.7796 124.3086)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 267.426,
    cy: 299.277,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9247 -0.3806 0.3806 0.9247 -91.7569 134.5374)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 294.301,
    cy: 299.277,
    rx: 8.939,
    ry: 8.939
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9184 -0.3957 0.3957 0.9184 -92.2032 151.4987)",
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 321.176,
    cy: 299.277,
    rx: 8.939,
    ry: 8.939
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 159.927,
    cy: 330.463,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 186.802,
    cy: 330.463,
    r: 8.939
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 1.001,
      strokeMiterlimit: 10
    },
    cx: 213.677,
    cy: 330.463,
    r: 8.939
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5521"
    },
    d: "M156.204,181.336l0.704-1.561c0.755,0.55,1.881,0.934,2.956,0.934c1.228,0,1.727-0.41,1.727-0.96 c0-1.676-5.207-0.525-5.207-3.851c0-1.523,1.228-2.789,3.774-2.789c1.126,0,2.277,0.268,3.109,0.793l-0.64,1.574 c-0.831-0.474-1.689-0.704-2.482-0.704c-1.228,0-1.702,0.461-1.702,1.024c0,1.65,5.208,0.512,5.208,3.8 c0,1.497-1.241,2.776-3.8,2.776C158.43,182.372,156.997,181.95,156.204,181.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A65C9"
    },
    d: "M189.904,182.219l-0.013-5.374l-2.635,4.427h-0.934l-2.623-4.312v5.259h-1.945v-8.957h1.714 l3.352,5.566l3.302-5.566h1.701l0.026,8.957H189.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A65C9"
    },
    d: "M212.64,174.951h-2.866v-1.689h7.805v1.689h-2.866v7.268h-2.073V174.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A65C9"
    },
    d: "M247.71,173.262l-2.93,8.957h-2.226l-1.971-6.065l-2.034,6.065h-2.213l-2.943-8.957h2.15 l2.022,6.295l2.111-6.295h1.919l2.047,6.346l2.086-6.346H247.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A65C9"
    },
    d: "M266.39,174.951h-2.866v-1.689h7.805v1.689h-2.866v7.268h-2.073V174.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A65C9"
    },
    d: "M292.99,174.926v2.367h4.145v1.664h-4.145v3.262h-2.073v-8.957h6.768v1.663H292.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A65C9"
    },
    d: "M317.453,181.336l0.704-1.561c0.755,0.55,1.88,0.934,2.956,0.934c1.228,0,1.727-0.41,1.727-0.96 c0-1.676-5.207-0.525-5.207-3.851c0-1.523,1.228-2.789,3.775-2.789c1.126,0,2.277,0.268,3.109,0.793l-0.64,1.574 c-0.831-0.474-1.689-0.704-2.482-0.704c-1.228,0-1.702,0.461-1.702,1.024c0,1.65,5.207,0.512,5.207,3.8 c0,1.497-1.241,2.776-3.8,2.776C319.679,182.372,318.246,181.95,317.453,181.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC40"
    },
    d: "M425.229,163.004H137.186v-27.928c0-5.946,4.82-10.765,10.765-10.765h266.513 c5.945,0,10.765,4.82,10.765,10.765V163.004z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 2.1337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M198.593,142.818c-10.221,0-18.508-8.286-18.508-18.508c0-10.222,8.286-18.508,18.508-18.508 c10.221,0,18.508,8.286,18.508,18.508"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 2.1337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M226.131,142.818c-10.221,0-18.508-8.286-18.508-18.508c0-10.222,8.286-18.508,18.508-18.508 c10.221,0,18.508,8.286,18.508,18.508"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 2.1337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M253.669,142.818c-10.222,0-18.508-8.286-18.508-18.508c0-10.222,8.286-18.508,18.508-18.508 c10.221,0,18.508,8.286,18.508,18.508"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 2.1337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M281.208,142.818c-10.221,0-18.508-8.286-18.508-18.508c0-10.222,8.286-18.508,18.508-18.508 c10.221,0,18.507,8.286,18.507,18.508"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 2.1337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M308.746,142.818c-10.221,0-18.507-8.286-18.507-18.508c0-10.222,8.286-18.508,18.507-18.508 c10.222,0,18.508,8.286,18.508,18.508"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 2.1337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M336.284,142.818c-10.221,0-18.507-8.286-18.507-18.508c0-10.222,8.286-18.508,18.507-18.508 c10.222,0,18.508,8.286,18.508,18.508"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#3A65C9",
      strokeWidth: 2.1337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M363.822,142.818c-10.221,0-18.508-8.286-18.508-18.508c0-10.222,8.286-18.508,18.508-18.508 c10.222,0,18.508,8.286,18.508,18.508"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 67.76 324.2044)",
    style: {
      fill: "#3A65C9"
    },
    cx: 425.229,
    cy: 80.309,
    rx: 33.302,
    ry: 33.302
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 425.229,
    cy: 80.309,
    r: 25.404
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFCC40",
      strokeWidth: 2.1337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 411.111,68.783 425.229,80.309 425.229,103.031  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A65C9"
    },
    d: "M522.744,189.27c7.881,2.561,24.387,9.119,40.456,15.683 c25.037,10.227,42.529,33.257,45.716,60.114c4.12,34.725,8.341,72.008,9.664,83.332c2.88,24.649-13.623,48.653-26.825,50.453 l5.101,17.703H458.234l-32.705-104.116c0,0-24.304,51.308-34.205,65.71c-9.901,14.402-38.106,25.204-59.709-4.201 c-21.603-29.404-41.106-71.036-41.106-71.036l31.633-19.296l33.177,40.524l23.894-66.738 c6.965-19.454,21.631-35.183,40.551-43.49l35.62-15.64L522.744,189.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC40"
    },
    d: "M527.034,190.75c-1.609-0.577-3.064-1.081-4.29-1.48l-67.36,9.001l-4.402,1.933l0,0 C462.585,216.274,507.142,223.925,527.034,190.75z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "502.413,308.538 469.366,308.538 460.958,247.729 494.005,247.729  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#283847",
      strokeWidth: 1.0766,
      strokeMiterlimit: 10
    },
    x1: 490.658,
    y1: 250.216,
    x2: 498.36,
    y2: 305.923
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283847"
    },
    d: "M468.2,253.548c0.135,0.977-0.547,1.769-1.524,1.769c-0.977,0-1.878-0.792-2.013-1.769 c-0.135-0.977,0.547-1.769,1.524-1.769C467.163,251.779,468.065,252.571,468.2,253.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283847"
    },
    d: "M474.067,253.548c0.135,0.977-0.547,1.769-1.524,1.769s-1.878-0.792-2.013-1.769 c-0.135-0.977,0.547-1.769,1.524-1.769C473.031,251.779,473.932,252.571,474.067,253.548z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#38518F"
    },
    points: "406.68,350.674 413.811,276.539 425.529,312.439  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1A294D",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 355.319,
    y1: 324.14,
    x2: 349.918,
    y2: 340.943
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38518F"
    },
    d: "M337.403,380.729c20.597,20.694,44.883,10.566,53.921-2.581c0.377-0.548,0.777-1.156,1.194-1.807 c-5.73-7.966-15.348-13.195-26.249-13.195C353.474,363.146,342.45,370.349,337.403,380.729z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1A294D",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 516.443,
    y1: 307.038,
    x2: 574.352,
    y2: 353.545
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38518F"
    },
    d: "M614.472,375.723c-4.985-3.69-11.359-5.906-18.308-5.906c-15.964,0-28.904,11.687-28.904,26.104 c0,1.589,0.166,3.142,0.467,4.652c7.209,0.845,15.447,0.625,24.027-1.722C604.031,395.493,610.781,385.228,614.472,375.723z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#38518F"
    },
    points: "489.319,319.082 517.601,309.713 494.769,328.424  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6969"
    },
    d: "M321.442,284.598l-18.936-29.266c0,0-6.41-11.808-12.599-16.277 c-2.838-2.049-9.043-7.739-10.17-9.219c0,0-3.48,1.163-1.813,4.834c1.667,3.671,7.183,9.973,7.183,9.973 s-14.161-3.145-19.39-4.65c-5.229-1.506-14.202-4.339-14.986-0.779c-0.863,3.917,19.927,8.492,19.927,8.492 s-5.182,1.094-3.182,6.56c-3.269,1.76-3.489,6.165,0.341,7.796c-2.153,2.64-0.179,6.705,5.423,6.704 c5.056,3.009,9.34,5.576,17.389,2.629l11.061,27.265L321.442,284.598z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B82C2C",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 270.658,
    y1: 247.706,
    x2: 281.668,
    y2: 250.808
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B82C2C",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 267.476,
    y1: 254.266,
    x2: 280.889,
    y2: 257.499
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B82C2C",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 267.817,
    y1: 262.062,
    x2: 280.009,
    y2: 262.767
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B82C2C",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 273.24,
    y1: 268.766,
    x2: 280.105,
    y2: 268.091
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B82C2C",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    d: "M281.98,268.057 c0,0,2.437-2.145-0.096-5.325c2.298-1.542,1.249-4.224,0.455-5.26c2.132-1.014,2.983-4.781,0.051-6.678"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B82C2C",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    d: "M283.951,255.705 c0,0,1.888,7.231,10.313,8.478"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#38518F"
    },
    points: "322.014,285.885 296.2,314.468 290.509,302.912  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6969"
    },
    d: "M512.699,305.903l-8.249-9.811c0,0,3.856-20.177-8.123-28.439c0,0,3.923,13.4-2.646,16.381 c-6.569,2.981-18.236,1.073-28.806-7.979l-0.528-4.202c0,0-2.898,6.736,1.27,9.668c-1.504,3.526-2.247,6.545,1.15,8.217 c-2.032,2.596-1.087,6.671,1.469,7.697c-2.4,4.501,1.9,8.001,6.501,8.487c2.973,0.314,13.988,0.619,13.988,0.619l8.029,9.291 L512.699,305.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC40"
    },
    d: "M425.529,278.133h29.18c0,0,11.726,35.473-5.877,35.473 C431.23,313.606,425.529,278.133,425.529,278.133z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#330909"
    },
    d: "M501.041,152.214c0,0,7.901-12.602,10.302-20.003c2.4-7.401-5.601-7.101-5.601-7.101 c1.1-8.201-1.8-11.502-8.201-11.702c-1.3-7.901-10.202-11.902-15.802-6.501c-8.001-8.001-20.403-2-20.103,9.401 c-9.902-2.1-13.496,20.153,0.903,23.629l27.201,15.437L501.041,152.214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6969"
    },
    d: "M466.035,127.611c0,0,15.452,8.401,27.904,5.851c0,0-0.9,4.801,3.15,7.201l-4.501,11.852l2.1,0.6 c0,0,4.651-10.051,10.202-8.101c5.551,1.95-0.9,20.703-10.802,15.152l8.101,23.254l20.553,5.851c0,0-7.501,20.103-40.506,20.103 c-17.103,0-26.854-11.102-26.854-11.102l17.103-6.601l-4.801-15.452c0,0-11.252,0.1-14.702-8.401 c-3.474-8.559,4.351-19.653,4.351-19.653L466.035,127.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B82C2C"
    },
    d: "M467.686,176.218c7.126,0.075,16.288-5.176,19.733-8.701c0,0-6.735,17.799-16.572,18.876 L467.686,176.218z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#B82C2C",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 472.486,
    y1: 191.67,
    x2: 475.337,
    y2: 199.096
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#330909"
    },
    d: "M469.817,153.234c0,0,6.37,1.58,7.37,4.281h-17.103c0,0,1.685-3.489,5.134-3.595 C465.219,153.92,467.347,154.905,469.817,153.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M464.535,157.515h8.901c0,0,0.95,10.977-2.3,10.977 C467.886,168.492,464.535,157.515,464.535,157.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#330909"
    },
    d: "M465.389,142.751c0,1.553-0.638,2.813-1.425,2.813c-0.787,0-1.425-1.259-1.425-2.813 c0-1.554,0.638-2.813,1.425-2.813C464.75,139.938,465.389,141.197,465.389,142.751z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#330909"
    },
    cx: 476.827,
    cy: 144.509,
    rx: 1.425,
    ry: 2.813
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    d: "M459.434,137.816l10.277,1.261 c0,0,0.9,10.441-6.901,9.483C455.009,147.603,459.434,137.816,459.434,137.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    d: "M473.023,139.483l10.276,1.261 c0,0,0.9,10.441-6.901,9.483C468.598,149.271,473.023,139.483,473.023,139.483z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 469.66,
    y1: 141.696,
    x2: 472.179,
    y2: 142.005
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 483.091,
    y1: 144.509,
    x2: 498.777,
    y2: 147.15
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#330909",
      strokeWidth: 2.1337,
      strokeMiterlimit: 10
    },
    x1: 475.402,
    y1: 136.462,
    x2: 485.201,
    y2: 136.05
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#330909",
      strokeWidth: 2.1337,
      strokeMiterlimit: 10
    },
    d: "M472.179,136.612 c0,0-4.502-3.941-8.811-2.702"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#330909",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    d: "M470.351,142.751l-5.316,11.109 c0,0,2.767,1.092,5.316-1.02"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#330909",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    d: "M495.49,155.365c0,0,3.3,1.15,3.851,0 c0.55-1.15-2.15-2.901-2.15-2.901s3.15-5.801,6.101-4.751c2.95,1.05-0.9,7.501-0.9,7.501"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#1A294D",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    d: "M591.754,398.852 c-12.902,4.201-43.507,5.106-63.91-21.001c-20.403-26.106-39.906-61.212-39.906-61.212"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1A294D",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 425.529,
    y1: 312.439,
    x2: 409.827,
    y2: 264.331
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1A294D",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 545.397,
    y1: 260.331,
    x2: 561.504,
    y2: 343.227
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "486.438,320.037 520.244,308.838 514.943,302.912 482.538,314.739  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "290.509,305.388 325.164,283.934 320.814,277.183 286.074,298.036  "
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFCC40"
    },
    cx: 457.784,
    cy: 437.934,
    rx: 31.355,
    ry: 7.951
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5521"
    },
    d: "M435.797,386.271l3.472,50.704h0.043c0,1.156,8.27,2.094,18.472,2.094 c10.202,0,18.472-0.938,18.472-2.094h0.043l3.472-50.704H435.797z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5521"
    },
    d: "M476.924,429.982c-6.769,0-10.497-7.131-10.497-20.079c0-8.925,6.49-16.187,14.467-16.187 c4.098,0,8.236,1.957,11.069,5.235c2.769,3.202,3.968,7.201,3.376,11.259C493.829,420.558,485.052,429.982,476.924,429.982z  M480.894,397.971c-5.631,0-10.212,5.352-10.212,11.932c0,3.712,0.45,15.824,6.243,15.824c5.368,0,12.9-7.196,14.204-16.132 l0,0c0.411-2.817-0.435-5.609-2.384-7.862C486.707,399.378,483.773,397.971,480.894,397.971z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M452.961,382.501c-1.714-4.408-3.918-6.612-1.959-11.755s4.424-6.734,4.6-11.387 c0.175-4.653-2.684-8.816-2.684-8.816s8.411,0.209,8.492,10.285C461.472,368.517,453.941,370.175,452.961,382.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M464.259,382.501c-1.714-4.408-3.918-6.612-1.959-11.755s4.424-6.734,4.6-11.387 c0.175-4.653-2.684-8.816-2.684-8.816s8.411,0.209,8.492,10.285C472.77,368.517,465.239,370.175,464.259,382.501z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDBF7"
    },
    d: "M267.683,345.159l-9.329-16.897l-9.329,16.897c-1.875,3.397-5.449,5.506-9.329,5.506h-62.25 c-5.885,0-10.656,4.771-10.656,10.656v76.383c0,5.885,4.771,10.656,10.656,10.656h161.815c5.885,0,10.656-4.771,10.656-10.656 v-76.383c0-5.885-4.771-10.656-10.656-10.656h-62.25C273.132,350.665,269.559,348.556,267.683,345.159z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.2169,
      strokeMiterlimit: 10
    },
    x1: 220.899,
    y1: 360.792,
    x2: 220.899,
    y2: 439.478
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5521"
    },
    d: "M192.152,376.815c-6.167,0.683-11.169,5.671-11.87,11.837c-0.449,3.948,0.809,7.599,3.129,10.32 c3.514,4.123,6.141,8.926,8.243,13.919l1.37,3.254c0.25,0.593,1.09,0.593,1.34,0l1.811-4.301 c2.024-4.807,4.894-9.173,8.126-13.266c1.813-2.296,2.895-5.193,2.895-8.346C207.197,382.267,200.3,375.912,192.152,376.815z  M193.695,395.471c-2.894,0-5.24-2.346-5.24-5.24c0-2.894,2.346-5.24,5.24-5.24c2.894,0,5.24,2.346,5.24,5.24 C198.934,393.125,196.588,395.471,193.695,395.471z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 235.8131 386.1839)",
    style: {
      fill: "#3A65C9",
      fontFamily: "'Montserrat-Bold'",
      fontSize: "24.2307px",
      letterSpacing: 2
    }
  }, "10:30"), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M325.114,398.272h-87.813c-1.271,0-2.3-1.03-2.3-2.3l0,0c0-1.27,1.03-2.3,2.3-2.3h87.813 c1.27,0,2.3,1.03,2.3,2.3l0,0C327.415,397.242,326.385,398.272,325.114,398.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M325.114,410.674h-87.813c-1.271,0-2.3-1.03-2.3-2.3l0,0c0-1.271,1.03-2.3,2.3-2.3h87.813 c1.27,0,2.3,1.03,2.3,2.3l0,0C327.415,409.644,326.385,410.674,325.114,410.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M267.606,437.478h-30.304c-1.271,0-2.3-1.03-2.3-2.3l0,0c0-1.27,1.03-2.3,2.3-2.3h30.304 c1.271,0,2.3,1.03,2.3,2.3l0,0C269.906,436.448,268.876,437.478,267.606,437.478z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#BEDBF7",
      strokeWidth: 1.0668,
      strokeMiterlimit: 10
    },
    x1: 137.186,
    y1: 168.492,
    x2: 137.186,
    y2: 229.836
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDBF7"
    },
    d: "M654.153,143.327c-5.507,5.507-11.49,8.454-13.362,6.583c-1.872-1.872,1.075-7.854,6.583-13.362 c5.507-5.507,11.49-8.454,13.361-6.582C662.607,131.838,659.66,137.82,654.153,143.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDBF7"
    },
    d: "M634.9,247.653c-5.507,5.507-11.49,8.454-13.362,6.583c-1.872-1.872,1.075-7.854,6.583-13.361 c5.507-5.507,11.49-8.454,13.361-6.583C643.354,236.163,640.407,242.145,634.9,247.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDBF7"
    },
    d: "M340.792,76.16c-5.507,5.507-11.489,8.454-13.361,6.582c-1.872-1.872,1.075-7.854,6.582-13.361 c5.507-5.507,11.49-8.455,13.361-6.583C349.247,64.671,346.3,70.653,340.792,76.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEDBF7"
    },
    d: "M638.071,193.33c-17.901,17.901-33.838,30.986-35.598,29.226s11.326-17.697,29.226-35.598 c17.901-17.901,33.838-30.986,35.597-29.226C669.057,159.492,655.972,175.43,638.071,193.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImage2);
export default __webpack_public_path__ + "static/media/bannerImage2.3fc83eb578192ced9e456844378656de.svg";
export { ForwardRef as ReactComponent };